import React, { useEffect } from 'react';
import { Row, Col, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  InputField,
  // RadioGroupField,
  HalfWidthInputField,
} from 'src/components/form';
import {
  MILLSHEET_OPTIONS,
  ROLL_EYES_OPTIONS,
} from 'src/constants/quotation/optionSelect';
import { FormValue } from '../useForm';

type Props = {
  visibleRollEyes: any;
  formInfo: any;
  isProductFinished: boolean;
};

const InputOptional: React.FC<Props> = ({
  visibleRollEyes,
  formInfo,
  isProductFinished,
}) => {
  const { control, setValue, watch } = formInfo;
  const { t } = useTranslation();

  const handleRadioGroupField = (type1: string, type: string) => {
    setValue(type1, type);
  };

  const typeRollEyes = watch('roll_eyes');
  const typeMillSheets = watch('mill_sheets');

  useEffect(() => {
    if (!watch('roll_eyes')) {
      setValue('roll_eyes', ROLL_EYES_OPTIONS(t)[0].value);
    }
    if (!watch('mill_sheets')) {
      setValue('mill_sheets', MILLSHEET_OPTIONS(t)[0].value);
    }
  }, []);

  return (
    <React.Fragment>
      {!isProductFinished && visibleRollEyes && (
        <Row align="middle" className="container_inputOptional">
          <Col xs={24} sm={4} md={4} xl={4}>
            <Typography.Text className="form_label_no_required radio_title">
              {t('pricing_page.roll_eyes')}
            </Typography.Text>
          </Col>
          <Col xs={24} sm={19} md={19} lg={19} xl={19}>
            {/* <RadioGroupField
              radioGroupProps={{
                options: ROLL_EYES_OPTIONS(t),
                defaultValue: ROLL_EYES_OPTIONS(t)[0].value,
              }}
              controller={{
                name: 'roll_eyes',
                control,
              }}
              className="input_tag radio_mt"
            /> */}
            <div className="custom-radio">
              <div
                onClick={() =>
                  handleRadioGroupField(
                    'roll_eyes',
                    ROLL_EYES_OPTIONS(t)[0].value,
                  )
                }
                className={`${
                  typeRollEyes === ROLL_EYES_OPTIONS(t)[0].value
                    ? 'active item'
                    : 'item'
                }`}
              >
                {ROLL_EYES_OPTIONS(t)[0].label}
              </div>
              <div
                onClick={() =>
                  handleRadioGroupField(
                    'roll_eyes',
                    ROLL_EYES_OPTIONS(t)[1].value,
                  )
                }
                className={`${
                  typeRollEyes === ROLL_EYES_OPTIONS(t)[1].value
                    ? 'active item'
                    : 'item'
                }`}
              >
                {ROLL_EYES_OPTIONS(t)[1].label}
              </div>
              <div
                onClick={() =>
                  handleRadioGroupField(
                    'roll_eyes',
                    ROLL_EYES_OPTIONS(t)[2].value,
                  )
                }
                className={`${
                  typeRollEyes === ROLL_EYES_OPTIONS(t)[2].value
                    ? 'active item'
                    : 'item'
                }`}
              >
                {ROLL_EYES_OPTIONS(t)[2].label}
              </div>
            </div>
          </Col>
        </Row>
      )}
      {!isProductFinished && (
        <Row align="middle">
          <Col xs={24} sm={4} md={4} lg={4} xl={4}>
            <Typography.Text className="form_label_no_required radio_title">
              {t('pricing_page.mill_sheet')}
            </Typography.Text>
          </Col>
          <Col xs={24} sm={19} md={19} lg={19} xl={19}>
            {/* <RadioGroupField
              radioGroupProps={{
                options: MILLSHEET_OPTIONS(t),
              }}
              controller={{
                name: 'mill_sheets',
                control,
                defaultValue: MILLSHEET_OPTIONS(t)[0].value,
              }}
              className="input_tag radio_mt"
            /> */}
            <div className="custom-radio">
              <div
                onClick={() =>
                  handleRadioGroupField(
                    'mill_sheets',
                    MILLSHEET_OPTIONS(t)[0].value,
                  )
                }
                className={`${
                  typeMillSheets === MILLSHEET_OPTIONS(t)[0].value
                    ? 'active item'
                    : 'item'
                }`}
              >
                {MILLSHEET_OPTIONS(t)[0].label}
              </div>
              <div
                onClick={() =>
                  handleRadioGroupField(
                    'mill_sheets',
                    MILLSHEET_OPTIONS(t)[1].value,
                  )
                }
                className={`${
                  typeMillSheets === MILLSHEET_OPTIONS(t)[1].value
                    ? 'active item'
                    : 'item'
                }`}
              >
                {MILLSHEET_OPTIONS(t)[1].label}
              </div>
            </div>
          </Col>
        </Row>
      )}

      <Row className="container_order_number">
        <Col xs={24} md={24} xl={24}>
          <HalfWidthInputField<FormValue>
            controller={{ control, name: 'order_number' }}
            inputProps={{
              placeholder: t('pricing_page.order_number'),
              minLength: 1,
              maxLength: 30,
            }}
            label={t('pricing_page.order_number')}
            labelCol={{ xs: 24, sm: 4, md: 4, xl: 4 }}
            wrapperCol={{ xs: 24, sm: 19, md: 19, xl: 19 }}
            className="input_tag update_size_lable"
          />
        </Col>
      </Row>
      <Row className="container_order_notes">
        <Col xs={24} md={24} xl={24}>
          <InputField<FormValue>
            controller={{ control, name: 'order_notes' }}
            inputProps={{
              placeholder: t('pricing_page.order_note'),
              minLength: 1,
              maxLength: 80,
            }}
            label={t('pricing_page.order_note')}
            labelCol={{ xs: 24, sm: 4, md: 4, xl: 4 }}
            wrapperCol={{ xs: 24, sm: 19, md: 19, xl: 19 }}
            className="input_tag update_size_lable"
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default InputOptional;
